export default 'https://tme.understood.org/assets/background.295418d0.glb'